<template>
    <ConfirmationModal
      ref="confirmationModal"
      :title="$t('reports.reports.titles.bulk_locking_modal')"
      :body="$t('reports.reports.messages.bulk_locking_modal_body', {count})"
      :okToClose="false"
      okClass="btn-primary"
      :okDisabled="isLoading"
      @modal-confirmed="onConfirm"
      @modal-canceled="onCancel"
      >
      <template slot="body">
        <small>{{$t('reports.reports.labels.bulk_lock_info')}}</small>
        &nbsp;
        <small v-if="form.data.lock">{{$t('reports.reports.labels.is_control_info')}}</small>
        <br>
        &nbsp;
        <div class="row">
          <div class="col-12 col-md-6 mb-3">
            <label class="fixed-label"><b class="title-label">{{$t('reports.reports.labels.report_state')}}:</b></label>
            <div class="d-flex mt-2">
              <slider v-model="form.data.lock"></slider>
              <span class="ml-3">{{form.data.lock ? this.$t('reports.reports.labels.report_state_locked') : this.$t('reports.reports.labels.report_state_unlocked')}}</span>
            </div>
          </div>
        </div>

        <div v-if="form.data.lock">
          <va-checkbox
            class="col"
            v-model="form.data.send_lock_email"
            :label="$t('reports.reports.labels.send_lock_email')"
          />
        </div>

        <LoadingAnimationCircle v-if="isLoading" class="d-flex justify-content-center pt-4 pb-4"></LoadingAnimationCircle>

      </template>
    </ConfirmationModal>
</template>

<script>
import ConfirmationModal from '@/components/common/ConfirmationModal'
import {ReportsService} from "@/api/ReportsService";
import Slider from '@/components/common/Slider'
import LoadingAnimationCircle from '@/components/common/LoadingAnimation'

export default {
  name: 'BulkLock',
  props: {
    serviceUrl: {
      type: String,
      required: true
    },
    params: {
      type: Object,
      required: true
    },
    count: {
      type: Number,
      required: true
    }
  },
  components: {
    ConfirmationModal,
    Slider,
    LoadingAnimationCircle,
  },
  data: function () {
    return {
      form: {
        data: {
          lock: true,
          send_lock_email: false,
          params: this.params
        }
      },
      isLoading: false
    }
  },
  methods: {
    onConfirm: function () {
      this.isLoading = true
      ReportsService
      .bulkLock(this.form.data)
      .then(response => {
        this.showToast(this.$t('reports.reports.messages.successful_bulk_lock'), this.$store.state.successToastOptions)
        this.$emit('bulkLock')
      })
      .catch(errors => {
        this.showToast(this.$t('reports.reports.messages.something_went_wrong'), this.$store.state.errorToastOptions)
      })
      .finally(() => {
        this.isLoading = false
      })
    },
    onCancel: function () {
      setTimeout(() => {
        this.$emit('modalWasClosed')
      }, 500)
    }
  }
}
</script>


<style scoped lang="scss">

label.fixed-label {
  justify-content: normal;
  font-size: 0.6rem;
  color: #29c4a9;
  font-weight: 600;
  text-transform: uppercase;
  top: -0.6rem;
  left: 0;
  margin-bottom: 0;
}

.title-label {
  color:#29c4a9 !important;
}

</style>
